import { render } from "./InfoBar.vue?vue&type=template&id=706f2022&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"

import "./InfoBar.vue?vue&type=style&index=0&id=706f2022&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706f2022"]])

export default __exports__